import { getToken } from "../cookie/authCookie";
import axiosInstance from "./config/axiosConfigs";

export const ProductAPI = {
  getAllProducts: async function (userId, clubId) {
    const response = await axiosInstance.request({
      url: `/ecommerce/product/all/userId/` + userId + "/club/" + clubId,
      method: "GET",
      withCredentials: true,
      timeout: 7000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  getAdvanceBooking: async function (userId, clubId) {
    const response = await axiosInstance.request({
      url: `/ecommerce/product/advance-booking/userId/` + userId + "/club/" + clubId,
      method: "GET",
      withCredentials: true,
      timeout: 7000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  getAllAdminProducts: async function () {
    const response = await axiosInstance.request({
      url: `/ecommerce/product/admin/all`,
      method: "GET",
      withCredentials: true,
      timeout: 2000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },


  postCreateProduct: async function (createProductInfo) {
    const response = await axiosInstance.request({
      url: `/ecommerce/product/create`,
      method: "POST",
      withCredentials: true,
      // timeout: 2000,
      data: createProductInfo,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  patchUpdateProductIsVisible: async function (reqData) {
    const response = await axiosInstance.request({
      url: `/ecommerce/product/update`,
      method: "PATCH",
      withCredentials: true,
      // timeout: 2000,
      data: reqData,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
};